import { useTranslations } from '@vocab/react';
import { useColor } from 'braid-design-system';

import translations from '../.vocab';
import SeekIcon from '../Campaign/SEEK_AYSF.png';
import type { BannerProps } from '../HomePageBanner';

import mobileSubtitle from './Campaign/Search-Bar-Tarzan-pinkbg.gif';
import desktopImage from './Campaign/Tarzan.png';
import mobileImage from './Campaign/TarzanHeadshot.png';

export const useDesktopTarzanCampaignContent = (): BannerProps => {
  const { t } = useTranslations(translations);
  const { background } = useColor();

  return {
    text: {
      title: t('Find the best job matches'),
      subTitle: {
        imageUrl: SeekIcon,
        altText: 'King. Jungle. No dress code.',
      },
      inverted: true,
    },
    background: {
      color: background.brandAccent,
      imageUrl: desktopImage,
      altText: 'Find the best job matches',
      containImage: true,
      backgroundPosition: 'bottom right',
    },
  };
};

export const useMobileTarzanCampaignContent = (): BannerProps => {
  const { t } = useTranslations(translations);
  const { background } = useColor();

  return {
    text: {
      title: t('Find the best job matches'),
      subTitle: {
        imageUrl: mobileSubtitle,
        altText: 'seek and you shall find',
        backgroundPosition: 'center',
      },
      inverted: true,
    },
    background: {
      color: background.brandAccent,
      imageUrl: mobileImage,
      altText: 'Find the best job matches',
      imageMinHeightVar: '340px',
      backgroundPosition: 'bottom',
    },
    logoImageUrl: SeekIcon,
  };
};
